module.exports = __webpack_public_path__ + "img/concrete-inner-corner-mask.87fb2f51.png";